import React, {useState, useEffect, useCallback, useRef} from 'react';
import {useHistory} from 'react-router-dom'
import VerifyOTP from './VerifyOTP'
import NewPassword from './NewPassword'
import Tick from '../../../Assets/Images/tick.png'
import GetEmail from './Email'
import GetCodes from './Codes'
import {encryptPassword} from '../../../Utils/Crypto'
import axios from 'axios'
import { showToast } from '../../../Component/Toast';
import Spinnner from '../../../Component/Loader'
import useClientHook from "../../../Hooks/useClientHook";
import useEmployeeHook from "../useEmployeeHook";

function Index() {
    const URL = useEmployeeHook()
    const params = new URLSearchParams(window.location.search)
    const HISTORY = useHistory();
    const [Stage, setStage] = useState(undefined);
    const [OTP, setOTP] = useState(undefined);
    const [Email, setEmail] = useState(params.get('email'));
    let {client_id, origin, provider} = useClientHook('LOGIN');
	const [loading, setLoading] = useState(false);
  const otpSent = useRef(false);

    const sendOTP = useCallback((email) => {
      if(!client_id || otpSent.current){
        return
      }
    otpSent.current = true
	  setLoading(true)
      axios.post(URL?.emailOtp||`https://auth.dice.tech/auth/employee/email.otp`, {email, client_id, ...(provider?{origin: provider}:undefined)}).then(res => {
            if(res){
                showToast({
                    type: 'success',
                    message: res.data.message || "OTP sent to your registered mail or phone"
                })
                setStage('OTP')
                setEmail(email)

            }
			setLoading(false);
        }).catch(err => {
            if(err.response){
                showToast({
                    type: 'error',
                    message: err.response.data.message
                })
            }else if(err.request){
                let msg = JSON.parse(err.request.response)
                showToast({
                    type: 'error',
                    message: msg.message
                })
            }

            if(email.includes('|')){
              HISTORY.push(`/reset?type=code&origin=${origin}&provider=${provider}`);
              setStage('CODES')
            }else{
              HISTORY.push(`/reset?origin=${origin}&provider=${provider}`)
              setStage('EMAIL')
            }
            setEmail(undefined);
			setLoading(false)

        })
    },[HISTORY, client_id, origin, provider,URL.emailOtp])

    useEffect(() => {
      if(!Stage){
        if(params.get('type')==='code'){
          if(params.get('id') && params.get('code')){
            sendOTP(`${params.get('id')}|${params.get('code')}`)
          }else{
            setStage('CODES')
          }
        }else{
          if(params.get('email')){
            sendOTP(params.get('email'))
          }else{
            setStage('EMAIL')
          }
        }
      }
    }, [params, sendOTP,Stage]);

    const submitForm = (password) => {
		setLoading(true)
      axios.post(URL?.password||`https://auth.dice.tech/auth/employee/password`, {email: Email, password: encryptPassword(Email,password), otp: OTP, client_id, ...(provider?{origin: provider}:undefined)}).then(res => {
            if(res){
             setStage('SUCCESS')
              setTimeout(() => {
                HISTORY.push(`/?origin=${origin}`)
              }, 2000);

            }
			setLoading(false)
          }).catch(err => {
            showToast({
              type: 'error',
              message: err.response.data?.message ? err.response.data?.message : "Invalid OTP, Retry"
            })
            setStage('OTP')
			setLoading(false)
        })
    }

    return (
      <div style={{overflow:'hidden'}}>
        {
            Stage==='CODES'
            ?<GetCodes loading={loading} origin={origin} onSuccess={(email)=>{sendOTP(email)}}/>
            :Stage==='EMAIL'
            ?<GetEmail loading={loading} origin={origin} onSuccess={(email)=>{sendOTP(email)}}/>
            :Stage==='OTP'&&Email
            ?<VerifyOTP provider={provider} origin={origin} client_id={client_id} email={Email} onSuccess={(otp)=>{setOTP(otp);setStage('PASSWORD')}}/>
            :Stage==='PASSWORD'&&Email&&OTP
            ?<NewPassword loading={loading} origin={origin} email={Email} onSuccess={submitForm}/>
            :Stage==='SUCCESS'
            ?<div className='vh-100 w-100 d-flex justify-content-center align-content-center' style={{background:'#fff'}}>
							<div className="p-5 text-center m-auto"  data-aos="fade-up"><img className="img-fluid mb-4 m-auto" src={Tick} style={{maxWidth: '80px'}} alt=""/>
                <h1 className="display-6 fw-bold">Password Changed</h1>
                <p>Password change was successfull. Login using new password.</p>
							</div>
            </div>
            :<div style={{width:'100%', height:'100vh', display: 'flex', background: '#fff', justifyContent: 'center', alignItems:'center'}}><Spinnner/></div>
        }
      </div>
    );
}

export default Index;
